import IMAGES from "@/data/treasuryImages.json";

export const ArtCredit = ({ imageId, prefix, dark = false }) => {
  const image = IMAGES[imageId];
  if (!image) return null;
  return <div data-testid={`${prefix}-credit`} className={`min-w-0 text-xs leading-relaxed ${dark ? "text-white/80" : "text-slateblue"}`}>
    <p>{image.artist || "Artist unknown"} · {image.licenseUrl ? <a href={image.licenseUrl} target="_blank" rel="noopener noreferrer" data-testid={`${prefix}-license`} className="underline underline-offset-2 transition-colors hover:text-gold">{image.license}</a> : image.license}</p>
    <p>{image.changes}</p>
    <a href={image.source} target="_blank" rel="noopener noreferrer" data-testid={`${prefix}-provenance`} className="underline underline-offset-2 transition-colors hover:text-gold">Image source · Wikimedia Commons</a>
  </div>;
};